import { NSARouterMakerResult, NSASectionList } from 'namirasoft-account-react';
import { FilterItem, FilterItemOperator } from 'namirasoft-core';
import { HistoryCreateRow, HistoryRow } from "namirasoft-history";
import { NamirasoftMap } from 'namirasoft-site-map';
import { NSSection, NSSpace, NSSpaceSizeType, NSTitle } from 'namirasoft-site-react';
import { HistoryEntities } from '../HistoryEntities';
import { HistoryRouterProps } from '../HistoryRouterProps';
import NSHChanges from './NSHChanges';

export interface NSHHistoryChangesProps
{
    props: NSARouterMakerResult & HistoryRouterProps;
    id: string;
    row: HistoryRow | null;
}

function NSHHistoryChanges({ props, id, row }: NSHHistoryChangesProps)
{
    if (!row)
        return null;

    let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

    let filters = [
        new FilterItem(namirasoft.history.tables.history, namirasoft.history.tables.history.columns.entity_id, false, FilterItemOperator.all.equals, row.entity_id),
        new FilterItem(namirasoft.history.tables.history, namirasoft.history.tables.history.columns.id, true, FilterItemOperator.all.equals, id)
    ];

    return (
        <>
            <NSSection>
                <NSSpace size={NSSpaceSizeType.NORMAL}></NSSpace>
                <NSTitle title='Changes' />
                <NSHChanges old_value={JSON.stringify(row.old_value, null, 4)} new_value={JSON.stringify(row.new_value, null, 4)} />
            </NSSection>
            <NSSpace size={NSSpaceSizeType.NORMAL}></NSSpace>
            <NSTitle title='History' />
            <NSASectionList<HistoryRow, HistoryCreateRow>
                key={row.id}
                {...props}
                entity={HistoryEntities.history(props, filters)}
                onIDsChanged={() => { }}
                ctf={{
                    enabled: false,
                    rows: null
                }}
            />
        </>
    );
}

export default NSHHistoryChanges;